var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrustpilotStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 20,
    viewBox: "0 0 107 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2660_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 0H21.6667V20H41.6667V0Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 0H43.3333V20H63.3333V0Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 0H65V20H85V0Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.667 0H86.6667V20H106.667V0Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 13.4792L13.0414 12.7083L14.3123 16.625L9.99976 13.4792ZM16.9998 8.41667H11.6456L9.99976 3.375L8.35392 8.41667H2.99976L7.33309 11.5417L5.68726 16.5833L10.0206 13.4583L12.6873 11.5417L16.9998 8.41667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6665 13.4792L34.7082 12.7083L35.979 16.625L31.6665 13.4792ZM38.6665 8.41667H33.3123L31.6665 3.375L30.0207 8.41667H24.6665L28.9998 11.5417L27.354 16.5833L31.6873 13.4583L34.354 11.5417L38.6665 8.41667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.333 13.4792L56.3747 12.7083L57.6455 16.625L53.333 13.4792ZM60.333 8.41667H54.9788L53.333 3.375L51.6872 8.41667H46.333L50.6663 11.5417L49.0205 16.5833L53.3538 13.4583L56.0205 11.5417L60.333 8.41667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9998 13.4792L78.0414 12.7083L79.3123 16.625L74.9998 13.4792ZM81.9998 8.41667H76.6456L74.9998 3.375L73.3539 8.41667H67.9998L72.3331 11.5417L70.6873 16.5833L75.0206 13.4583L77.6873 11.5417L81.9998 8.41667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6665 13.4792L99.7082 12.7083L100.979 16.625L96.6665 13.4792ZM103.667 8.41667H98.3123L96.6665 3.375L95.0207 8.41667H89.6665L93.9998 11.5417L92.354 16.5833L96.6873 13.4583L99.354 11.5417L103.667 8.41667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2660_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.667,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotStars);
export default __webpack_public_path__ + "static/media/trustpilot-stars.04196dc39489a4e80870311bbb9fd224.svg";
export { ForwardRef as ReactComponent };